import React, { memo } from "react";
import { Map, Marker } from "react-map-gl/mapbox";
import RouteSource from "./RouteSource";
import { convertToMapboxFormat } from "../utils/wayfinderUtils";

const WayfinderMap = memo(
  ({
    viewState,
    setViewState,
    userLocation,
    bibData,
    locationConfirmed,
    showDirections,
    routeStartLocation,
    routeEndLocation,
    selectedRoute,
    onRouteFound,
    hasUserInteracted,
    setHasUserInteracted,
    resetMapView,
  }) => {
    return (
      <div className="map-container">
        {/* Floating Reset Button - only show when user has manually interacted */}
        {hasUserInteracted && resetMapView && (
          <button
            className="map-reset-button"
            onClick={resetMapView}
            title="Reset map view to your location"
          >
            <i className="fas fa-crosshairs"></i>
          </button>
        )}
        <Map
          {...viewState}
          onMove={(evt) => {
            setViewState(evt.viewState);
            // Mark that user has manually interacted with the map
            if (setHasUserInteracted && !hasUserInteracted) {
              setHasUserInteracted(true);
            }
          }}
          style={{ height: "100%", width: "100%" }}
          mapStyle="mapbox://styles/mapbox/light-v11"
          mapboxAccessToken="pk.eyJ1Ijoibnh0aW50ZXJhY3RpdmUiLCJhIjoiY21laXU1cHIxMDRzdDJrczY5cWhjOGhwMCJ9.RUKpP8_lBssBuBo8DhCmfA"
        >
          {/* User Location Marker */}
          <Marker
            longitude={userLocation[0]}
            latitude={userLocation[1]}
            anchor="bottom"
          >
            <div className="current-location-marker">
              <div className="current-location-dot"></div>
              <div className="current-location-pulse"></div>
            </div>
          </Marker>

          {/* Assembly Point Marker - show after location confirmation */}
          {bibData &&
            locationConfirmed &&
            (() => {
              const assemblyCoords = convertToMapboxFormat(
                bibData.assemblyCoordinates
              );
              if (!assemblyCoords) return null;

              return (
                <Marker
                  longitude={assemblyCoords[0]}
                  latitude={assemblyCoords[1]}
                  anchor="bottom"
                >
                  <div className="assembly-point-marker">
                    <div className="assembly-point-icon"></div>
                  </div>
                </Marker>
              );
            })()}

          {/* Route Control - show path only after directions button clicked */}
          {bibData &&
            locationConfirmed &&
            showDirections &&
            routeStartLocation &&
            routeEndLocation && (
              <RouteSource
                key={`route-${showDirections ? 'show' : 'hide'}`}
                sourceId="main-route"
                start={routeStartLocation}
                end={routeEndLocation}
                // Use via-point routing for road-following
                disableApi={false}
                waypoints={window.routeWaypoints || undefined}
                onRouteFound={onRouteFound}
              />
            )}
        </Map>
      </div>
    );
  }
);

WayfinderMap.displayName = "WayfinderMap";

export default WayfinderMap;
